<template>
    <v-row class="fill-height my-0" id="normal_order_cart">
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-col cols="12" md="12" sm="12" class="py-0">
            <app-card class="fill-height d-flex flex-column py-0 topo" contentStyle="display: flex; flex-direction: column; height: 100%">
                <template v-slot:title>
                    <v-card-title class="d-flex justify-space-between align-center title-text dark-blue-color mx-1">
                        {{ $t('orders.summary.title') }}
                        <v-spacer></v-spacer>

                        <!-- <div class="d-flex justify-end">
                            <app-dialog :value="isHelpDialogOpen" @input="isHelpDialogOpen = $event" :title="$t('common.help')" width="40vw">
                                <template v-slot:content></template>

                                <template v-slot:buttons="{}">
                                    <v-btn text outlined class="myprovet-btn-cancel" @click="isHelpDialogOpen = false" data-cy="app-dialog-help-close-btn">{{ $t('common.close') }}</v-btn>
                                </template>
                            </app-dialog>

                            <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="appbar-icon-button-small btn-bg-color-white dark-blue-color mr-1" style="cursor: pointer" data-cy="help-filter-card" @click.stop="isHelpDialogOpen = true"> mdi-help-circle-outline </v-icon>
                                </template>

                                <span>{{ $t('common.help') }}</span>
                            </v-tooltip>
                        </div> -->
                    </v-card-title>

                    <v-card-subtitle class="mx-1 pt-1" style="min-height: 42px">{{ $t('orders.summary.subtitle') }}</v-card-subtitle>
                </template>

                <template v-slot:content>
                    <shopping-cart summaryPage :hasItems="hasItems" :account-blocked-message="accountBlockedMessage" class="d-flex flex-column fill-height"></shopping-cart>

                    <v-row class="pt-4" v-if="hasItems">
                        <v-col cols="12" md="6" sm="6"> </v-col>

                        <v-col cols="12" md="6" sm="6">
                            <v-row v-if="!isMobile">
                                <v-col cols="12" md="4"> </v-col>

                                <v-col cols="12" md="4">
                                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="goBack()" data-cy="go-back-btn">{{ $t('common.back') }}</v-btn>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <template>
                                        <v-btn text class="myprovet-btn-ok px-8" @click="isConfirmDialogOpen = true" data-cy="summary-order-btn">{{ $t('common.order') }}</v-btn>
                                    </template>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col col="6" md="6" sm="6">
                                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="goBack()" data-cy="go-back-btn">{{ $t('common.back') }}</v-btn>
                                </v-col>
                                 <v-col cols="6" md="6" sm="6">
                                        <v-btn text class="myprovet-btn-ok px-8" @click="isConfirmDialogOpen = true" data-cy="summary-order-btn">{{ $t('common.order') }}</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <alert-message-dialog :value="isBlockedDialogOpen" @on-cancel="isBlockedDialogOpen = false" width="80vw" :url="'/api/account-blocked'"> </alert-message-dialog>
                </template>
            </app-card>
        </v-col>

        <payment-method-dialog
            :key="document_number"
            v-if="isOrderZero"
            @on-success="clearAndExit()"
            @input="validatePaymentMethod($event)"
            :isPaymentMethodDialogOpen="isPaymentMethodDialogOpen"
            :serie="serie"
            :document_number="document_number"
            :document_id="document_id"
            :redirect="true"
        ></payment-method-dialog>
        <confirmation-dialog :value="isConfirmDialogOpen" @onSuccess="finishOrder()" @onCancel="isConfirmDialogOpen = false" :title="$t('layout.attention')" :question="$t('orders.summary.confirmQuestion')" width="50vw"> </confirmation-dialog>
        <confirmation-dialog :value="isUpdatePricesDialogOpen" @onSuccess="updatePrices()" @onCancel="isUpdatePricesDialogOpen = false" :title="$t('layout.attention')" :question="$t(updatePriceQuestion)"> </confirmation-dialog>
    </v-row>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAppStore } from '@/Stores/app';
import { axios } from '@/Services/Backend';
import MainLayout from './../../Layouts/MainLayout';

export default {
    layout: MainLayout,

    props: {
        zeroOrderLimit: Object,
        accountBlockedMessage: String,
    },

    data: () => ({
        isLoading: false,
        contentCardHeight: '80.5vh',
        isHelpDialogOpen: false,
        isBlockedDialogOpen: false,
        isConfirmDialogOpen: false,
        isPaymentMethodDialogOpen: false,

        isUpdatePricesDialogOpen: false,
        updatedCampaigns: null,
        updatedProducts: null,


        serie: null,
        document_number: null,
        document_id: null,
        status: null,
        isCreated: false, // Used to check if the page was refreshed with payment methods dialog conditions
        updatePriceQuestion: 'orders.summary.pricesChanged',
    }),

    watch: {
        'branchStore.branch': {
            handler: function (newBranch, oldBranch) {
                // @Note: Return to dashboard when changing clients on this page
                if (newBranch && oldBranch) {
                    this.$inertia.visit('/dashboard');
                }
            },
        },

        'normalOrderStore.getIsAwaitingPaymentMethodSelection': {
            handler: function (isAwaitingPaymentMethodSelection) {
                if (!this.isCreated && isAwaitingPaymentMethodSelection) this.clearAndExit();
            },
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore,useAppStore),

        hasItems() {
            return this.normalOrderStore.getProductCount > 0 || this.normalOrderStore.getCampaignCount > 0;
        },

        shoppingCartSubtotal() {
            return this.normalOrderStore.getProductsSubtotal;
        },

        isOrderZero() {
            if (!this.userStore.hasPermissionTo('Finish orders')) return false;
            if (!this.userStore.hasPermissionTo('Access zero orders')) return false;
            if (!this.branchStore.branch?.has_zero_order) return false;
            if (this.normalOrderStore.isBudgetRequest) return false;
            if (!this.zeroOrderLimit) return false;
            if (this.branchStore.branch?.zone === 'ILHAS') return false;
            if (this.isPaymentMethodDialogOpen) return true;

            let total = this.normalOrderStore.getCartTotal ?? 0;
            return this.zeroOrderLimit.active && this.zeroOrderLimit.value > 0 && total > 0 && total <= this.zeroOrderLimit.value;
        },
        isMobile(){
            return this.appStore.mobile_ls?false:this.appStore.is_mobile;
        }
    },

    methods: {
        validatePaymentMethod(input) {
            if (input === 'closedWithNoMethod') {
                this.isLoading = true;
                this.isPaymentMethodDialogOpen = false;
                this.clearAndExit(0, this.userStore.hasPermissionTo('View orders awaiting payment') ? '/orders/awaiting-payment' : null);
            } else {
                this.clearAndExit(0);
            }
        },

        goBack() {
            const client_number = this.branchStore.branch?.client_number;
            const company_branch = this.branchStore.branch?.company_branch;

            this.$inertia.visit(`/orders/normal/cart/${client_number}/${company_branch}`);
        },

        finishOrder() {

            if(this.isLoading) return;

            this.isConfirmDialogOpen = false;
            this.isCreated = true;
            this.isLoading = true;

            const products = this.normalOrderStore.getProducts.map((product) => {
                // If a product has an substitute set, we'll want to send the substitute.
                if (product.selected_substitute_product) {
                    // There are fields that must be moved over to the new product.
                    product.selected_substitute_product.quantity = product.quantity;
                    product.selected_substitute_product.observation = product.observation;

                    return product.selected_substitute_product;
                }
                return product;
            });

            if (!this.userStore.hasPermissionTo('Finish orders')) {
                this.setCartAsPending(products);
                return;
            }

            // Branch account status 7 and 16, cannot create orders
            if (this.branchStore.branch.account_status.id === 7 || this.branchStore.branch.account_status.id === 16) {
                this.isLoading = false;
                this.showError(this.$t('orders.summary.processError'));
                return;
            }

            let dataToPost = {
                branch_id: this.branchStore.branch.id,
                products: products,
                campaigns: this.normalOrderStore.getCampaigns,
                phc_stamp: this.normalOrderStore.getDeliveryAddress.phc_stamp,
                observation: this.normalOrderStore.getObservation,
                is_zero_order: this.isOrderZero,

                //Additional info
                isBudgetRequest: this.normalOrderStore.isBudgetRequest,
                isScheduledOrder: this.normalOrderStore.isScheduledOrder,
                scheduledOrderDate: this.normalOrderStore.getScheduledOrderDate,
                isLaboratoryOrder: this.normalOrderStore.isLaboratoryOrder,
                isFirstOrder: this.normalOrderStore.isFirstOrder,
                firstOrderDiscount: this.normalOrderStore.getFirstOrderDiscount?.percentage,
            };

            if (this.normalOrderStore.getIsPendingCart) {
                dataToPost.isPendingCart = this.normalOrderStore.getIsPendingCart;
                dataToPost.pendingCartId = this.normalOrderStore.getPendingCartId;
            }

            axios
                .post('/api/orders/normal/create', dataToPost)
                .then((response) => {
                    this.isLoading = false;
                    if (this.isOrderZero) {
                        this.serie = response.data.serie;
                        this.document_number = response.data.document_number;
                        this.document_id = response.data.document_id;
                        this.status = response.data.status;

                        if (response.data.document_id) {
                            this.normalOrderStore.setIsAwaitingPaymentMethodSelection(true);
                            this.isPaymentMethodDialogOpen = true;
                        } else {
                            // If the order is not sent to the PHC or the document_id is not returned
                            this.clearAndExit();
                        }
                    } else {
                        this.clearAndExit();
                    }
                })
                .catch(this.onStoreFailure);
        },

        setCartAsPending(products) {
            axios
                .post('/api/orders/pending-carts/store', {
                    branch_id: this.branchStore.branch.id,
                    products_json: JSON.stringify(this.normalOrderStore.getProducts),
                    campaigns_json: JSON.stringify(this.normalOrderStore.getCampaigns),
                    products: products,
                    campaigns: this.normalOrderStore.getCampaigns,
                    phc_stamp: this.normalOrderStore.getDeliveryAddress.phc_stamp ?? null,
                    observation: this.normalOrderStore.getObservation,

                    // Additional info
                    isBudgetRequest: this.normalOrderStore.isBudgetRequest,
                    isScheduledOrder: this.normalOrderStore.isScheduledOrder,
                    scheduledOrderDate: this.normalOrderStore.getScheduledOrderDate,
                    isLaboratoryOrder: this.normalOrderStore.isLaboratoryOrder,
                    isFirstOrder: this.normalOrderStore.isFirstOrder,
                    firstOrderDiscount: this.normalOrderStore.getFirstOrderDiscount?.percentage,
                })
                .then(() => {
                    this.isLoading = false;
                    this.clearAndExit();
                })
                .catch(this.onStoreFailure);
        },

        onStoreFailure(error) {
            this.isLoading = false;
            console.error(error);

            if (error.response?.data?.message === 'user-blocked') {
                window.location.reload();
                return;
            }

            if (error.response?.data?.message === 'branch-blocked') {
                this.isBlockedDialogOpen = true;
                return;
            }

            // The prices are outdated, the user needs to be notified.
            if (error.response?.data?.message === 'invalid-prices') {
                this.updatedProducts = error.response?.data?.products;
                this.isUpdatePricesDialogOpen = true;
                return;
            }

            // The campaign prices are outdated, the user needs to be notified.
            if (error.response?.data?.message === 'invalid-campaign-prices') {
                // Ask the user if he wants to update the prices.
                this.updatedCampaigns = error.response?.data?.campaigns;
                this.updatePriceQuestion = 'orders.summary.campaignPricesChanged'
                this.isUpdatePricesDialogOpen = true;
                return;
            }

            this.showError(error.response?.data?.message ?? this.$t('orders.summary.processError'));
        },

        updatePrices() {
            if (this.updatedCampaigns) {
                this.normalOrderStore.updateCampaignPrices(this.updatedCampaigns);
            }

            if (this.updatedProducts) {
                this.normalOrderStore.updateProductPrices(this.updatedProducts);
            }

            this.updatedCampaigns = null;
            this.updatedProducts = null;
            this.isUpdatePricesDialogOpen = false;
        },

        clearAndExit(timeout = 3000, url = null) {
            this.normalOrderStore.finishPurchase(!this.isOrderZero);

            setTimeout(() => {
                const clientNumber = this.branchStore.branch?.client_number;
                const companyBranch = this.branchStore.branch?.company_branch;
                if (this.$page.url == `/orders/normal/summary/${clientNumber}/${companyBranch}`) {
                    this.$inertia.visit(url ?? '/dashboard'); // if receiving an url to override the destination, go there instead
                }
            }, timeout);
        },
    },
};
</script>

<style></style>
